import { FluidilyStore, createStores } from "./context";

const store: FluidilyStore = createStores();

export const useStores = (): FluidilyStore => store;
